import React from "react";
import './Navbar.css';

export default class Navbar extends React.Component {

    render() {
        return <header id="navbar" class="navbar">
            <div class="navImages">
                <a href={"/"}><img id="logo" src={"logos/ewb_wpi.png"} /></a>
                <img id="hamburger" src="icons/hamburger.png" onClick={() => toggleNavMenu()} />
            </div>
            <div class="nav">
                <div style={{ overflow: "hidden", padding: "6px 0px"}}>
                    {/* ////////////////////////////////////////////////////////////////////////////////////// */}
                    {/* Pages on the top navigation bar are set here: */}
                    <a href={"/"}>HOME</a>

                    <Dropdown title="ABOUT">
                        <a href={"/AboutUs"}>ABOUT US</a>
                        <a href={"/ExecutiveBoard"}>EXECUTIVE BOARD</a>
                        <a href={"/Conferences"}>CONFERENCES</a>
                        <a href={"/OurHistory"}>OUR HISTORY</a>
                    </Dropdown>

                    <Dropdown title="PROJECTS">
                        <a href={"/Shungubug"}>SHUNGUBUG, ECUADOR</a>
                        <a href={"/ElCisne"}>EL CISNE, ECUADOR</a>
                        <a href={"/Guachtuq"}>GUACHTUQ, GUATEMALA</a>
                    </Dropdown>

                    <a href={"/GetInvolved"}>GET INVOLVED</a>

                    <a href={"/Events"}>EVENTS</a>

                    <a href={"/Sponsors"}>SPONSORS</a>

                    <a class="highlightedButton" href={"/Donate"}>DONATE</a>
                    {/* ////////////////////////////////////////////////////////////////////////////////////// */}
                </div>
            </div>
        </header>;
    }
}

//Dropdown component used above
function Dropdown(props) {
    return (
        <div class="dropdown" onClick={(event) => toggleSubmenu(event.target.parentElement)}>
            {window.matchMedia("only screen and (min-width: 768px)").matches ? <a href={props.children[0].props.href}>{props.title}</a> : <a>{props.title}</a>}
            <div class="dropdownOptions">
                <div style={{ overflow: "hidden" }}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

//Helper functions

function toggleNavMenu() {
    const navbar = document.getElementById("navbar");

    if (navbar.className === "navbar") {
        navbar.className += " show";
    }
    else {
        navbar.className = "navbar";

    }
}

function toggleSubmenu(dropdown) {
    if (window.matchMedia("only screen and (min-width: 768px)").matches) { return; }//Do nothing if in desktop view
    
    if (dropdown.className === "dropdown") {
        //close other submenus
        const openDropdown = document.getElementsByClassName("dropdown show")[0];
        if (openDropdown) {
            openDropdown.className = "dropdown";
        }

        //Open this submenu
        dropdown.className += " show";
    }
    else {
        dropdown.className = "dropdown";

    }
}